import { useState } from "react";
import Icon from "../Icon";

const DownloadElements = ({ chart, mode, PType }) => {
    const [hoveredLink, setHoveredLink] = useState(null);
    return (<div id="export-container">

        {mode==="dark"&&chart.darkImg&&<a
            className={`button btn btn-primary ${"PNGD" === hoveredLink && 'bg-' + PType}`}
            href={`${window.PUBLICATION_DATA_URL}exports/${chart.kiadvany}/${chart.htmlname}/${chart.darkImg}`} download
            onMouseEnter={() => setHoveredLink("PNGD")}
            onMouseLeave={() => setHoveredLink(null)}><Icon icon="png" className={"PNGD" === hoveredLink ? 'black': "white"} />
        </a>}

        {mode!=="dark"&&chart.lightImg&&<a
            className={`button btn btn-primary ${"PNG" === hoveredLink && 'bg-' + PType}`}
            href={`${window.PUBLICATION_DATA_URL}exports/${chart.kiadvany}/${chart.htmlname}/${chart.lightImg}`} download
            onMouseEnter={() => setHoveredLink("PNG")}
            onMouseLeave={() => setHoveredLink(null)}><Icon icon="png" className={"PNG" === hoveredLink ? 'black': "white"} />
        </a>}
        {chart && chart.csv&&<a
            className={`button btn btn-primary  ${"CSV" === hoveredLink && 'bg-' + PType}`}
            href={`${window.PUBLICATION_DATA_URL}exports/${chart.kiadvany}/${chart.htmlname}/${chart.csv}`} download
            onMouseEnter={() => setHoveredLink("CSV")}
            onMouseLeave={() => setHoveredLink(null)}><Icon icon="csv" className={"CSV" === hoveredLink ? 'black': "white"} />
        </a>}

        </div>)
}

export default DownloadElements;
